import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { isEmpty } from '@semios/app-platform-common'
import { MAP_VISUAL } from 'stores/mapControlsStore/types'
import { apiFetch } from 'utils/apiFetch'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import type { TGetCacheUpdatesFromResponseParameters, TGetCacheUpdatesFromResponseReturn } from './_types'
import { generateUsualStyleAPIArgs } from './_utils/generateUsualStyleAPIArgs'
import { generateUsualStyleGetCacheUpdatesFromResponse } from './_utils/generateUsualStyleGetCacheUpdatesFromResponse'
import { getValueType } from './_utils/getValueType'

const heatmapExtremesForAllPropertiesInVisibleRegions = true
const valueGroup = 'precipitation'

const makeApiArgs = (
  processedCaches: TGetCacheUpdatesFromResponseParameters['processedCaches'],
): routes.ValuesCurrent.Request => {
  return generateUsualStyleAPIArgs({
    heatmapExtremesForAllPropertiesInVisibleRegions,
    processedCaches,
    outOfBlockPoint: {
      valueType: getValueType(MAP_VISUAL.POINT, valueGroup),
    },
    inBlockPoint: {
      valueType: getValueType(MAP_VISUAL.POINT, valueGroup),
    },
    property: {
      valueType: getValueType(MAP_VISUAL.PROPERTY, valueGroup),
    },
    region: {
      valueType: getValueType(MAP_VISUAL.REGION, valueGroup),
    },
  })
}

export const getResponseAndShapeForCacheUpdate = async ({
  cacheKeys,
  processedCaches,
}: TGetCacheUpdatesFromResponseParameters): Promise<TGetCacheUpdatesFromResponseReturn> => {
  const args = makeApiArgs(processedCaches)

  if (isEmpty(args)) return {}

  const response = await apiFetch({ url: '/values-current', body: args })

  return generateUsualStyleGetCacheUpdatesFromResponse({
    cacheKeys,
    heatmapExtremesForAllPropertiesInVisibleRegions,
    processedCaches,
    response,
    outOfBlockPoint: {
      unitConverterFunction: (val?: number | null) => unitConverter.precipitation(val, undefined),
      valueType: getValueType(MAP_VISUAL.POINT, 'precipitation'),
    },
    inBlockPoint: {
      unitConverterFunction: (val?: number | null) => unitConverter.precipitation(val, undefined),
      valueType: getValueType(MAP_VISUAL.POINT, 'precipitation'),
    },
    property: {
      valueType: getValueType(MAP_VISUAL.PROPERTY, 'precipitation'),
      unitConverterFunction: (val?: number | null) => unitConverter.precipitation(val, undefined),
    },
    region: {
      valueType: getValueType(MAP_VISUAL.REGION, 'precipitation'),
      unitConverterFunction: (val?: number | null) => unitConverter.precipitation(val, { decimalPlaces: 1 }),
    },
  })
}
